import moment from 'moment';

import CompanyLogo from '~/components/CompanyLogo';
import Avatar from '~/components/PersonAvatar';
import { TableCell, TableRow } from '~/components/Table';
import { deepDig } from '~/lib/helpers';
import history from '~/lib/history';
import paths from '~/lib/paths';

import styles from './styles';

const columnComponents = {
  'company->name': ColumnCompanyName,
  last_visit_at: ColumnTimestamp,
  name: ColumnName,
};

const imageSize = 24;

function Person({ classes, columns, person, segmentId, style }) {
  return (
    <TableRow
      hover
      onClick={() => {
        const path = paths.person(person.id, segmentId);
        history.push(path);
      }}
      style={style}>
      {columns.map((column) => {
        const Column = columnComponents[column] || ColumnWithFallback;
        const title = deepDig(person.columns, column);

        return (
          <TableCell
            className={classes.root}
            ellipsis
            key={column}
            title={title}>
            <Column classes={classes} column={column} person={person} />
          </TableCell>
        );
      })}
    </TableRow>
  );
}

function ColumnName({ classes, column, person }) {
  const image = <Avatar size={imageSize} src={person.avatar} />;

  return (
    <ColumnImage
      classes={classes}
      column={column}
      image={image}
      person={person}
    />
  );
}

function ColumnCompanyName({ classes, column, person }) {
  const domain = person.company ? person.company.domain : null;
  const image = <CompanyLogo domain={domain} size={imageSize} />;

  return (
    <ColumnImage
      classes={classes}
      column={column}
      image={image}
      person={person}
    />
  );
}

function ColumnImage({ classes, column, image, person }) {
  return (
    <div className={classes.columnImage}>
      {image}

      <ColumnWithFallback
        as="div"
        className={classes.columnImageText}
        column={column}
        person={person}
      />
    </div>
  );
}

function ColumnTimestamp({ classes: _classes, column, person }) {
  const value = deepDig(person.columns, column);

  return <>{value ? moment(value).fromNow() : '—'}</>;
}

function ColumnWithFallback({
  as,
  classes: _classes,
  column,
  person,
  ...props
}) {
  const Component = as || React.Fragment;
  const value = deepDig(person.columns, column, '—');

  return <Component {...props}>{value}</Component>;
}

export default withStyles(styles)(Person);
